import React, {Fragment, useContext, useState } from "react";
import { RootStoreContext } from "../../core/store/rootStore";
import LoadingOverlay from "react-loading-overlay";
import {toast} from "react-toastify";
import {Container, Navbar, NavbarBrand, Spinner} from "reactstrap";
import { history } from "./../../index";

const ForgotPassword = () => {

    const rootStore = useContext(RootStoreContext);
    const { newRecoveryPasswordData, resetPassword } = rootStore.userStore;

    let [passwordRecoveryData, setPasswordRecoveryData] = useState(newRecoveryPasswordData(window.location.pathname.split("/")[2]));
    const [apiLoading, setApiLoading] = useState(false);

    const resetPasswordAction = (e) => {
        e.preventDefault();

        if (passwordRecoveryData.password !== passwordRecoveryData.repeatPassword) {
            toast.error("Les mots de passe ne correspondent pas");
            return;
        }

        setApiLoading(true);
        resetPassword(passwordRecoveryData).then((result) => {
            setApiLoading(false);
            if (result) {
                toast.success("Le changement de mot de passe a fonctionné correctement, veuillez vous connecter en utilisant vos nouvelles informations d'identification.");
                history.push("/login");
            }
            else {
                toast.error("Nous n'avons pas été en mesure de changer votre mot de passe. Veuillez réessayer ou recommencer le processus.");
            }
        });
    };

    const inputChange = (e) => {
        const { name, value } = e.target;
        let realValue = value;

        if (JSON.parse(e.target.getAttribute("data-number")))
            realValue = Number(realValue);

        setPasswordRecoveryData((lastUpdate) => ({
            ...lastUpdate,
            [name]: realValue,
        }));
    };

    return (
        <Fragment>
          <Navbar
            className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow"
            light
          >
            <Container>
              <NavbarBrand>
                <img
                  src="/logo.png"
                  alt="logo"
                  style={{ width: 150 }}
                />
              </NavbarBrand>
            </Container>
          </Navbar>
            <div className="wrap">
              <LoadingOverlay
                  active={apiLoading}
                  spinner>
                <form className="login-form" onSubmit={resetPasswordAction}>
                  <div className="form-header">
                    <h3>EASYcreditcheck</h3>
                    <p>Récupération du mot de passe</p>
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-input"
                      name="username"
                      placeholder="Nom d'utilisateur"
                      value={passwordRecoveryData.username}
                      onChange={inputChange}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      name="password"
                      type="password"
                      className="form-input"
                      placeholder="Mot de passe"
                      value={passwordRecoveryData.password}
                      onChange={inputChange}
                    />
                  </div>
                  <div className="form-group">
                      <input
                          name="repeatPassword"
                          type="password"
                          className="form-input"
                          placeholder="Répétez votre mot de passe"
                          value={passwordRecoveryData.repeatPassword}
                          onChange={inputChange}
                      />
                  </div>
                  <div className="form-group">
                    <button className="form-button" type="submit">Modifier</button>
                  </div>
                  <div className="form-footer"></div>
                </form>
              </LoadingOverlay>
            </div>
        </Fragment>
    );
};

export default ForgotPassword;